import { observer } from 'mobx-react-lite'
import { Handle, Position } from '@xyflow/react'
import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import { type ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { CallEndsStore } from '../../store/CallEndsStore'
import styles from './styles.module.scss'

export const CallEndsNode = observer(({ viewOnly }: ISmartCallNodeProps) => {
  return (
    <>
      <Handle
        type='target'
        position={Position.Top}
        style={{ background: 'transparent', border: 'none', outline: 'none' }}
      />
      <div className={classNames(styles.wrap, { [styles.viewOnly]: viewOnly })}>
        <Icon icon={'phoneHangUp'} color={'var(--content-primary-secondary-inverted)'} />
        <Typography ariaLabel={'End'} variant={'body-md-regular'}>
          {CallEndsStore.title}
        </Typography>
      </div>
    </>
  )
})
